import { ReactComponent as EmojiIcon } from 'assets/icons/addEmoji16.svg'
import Picker from '@emoji-mart/react'
import { BaseEmoji } from 'types'
import { IconButton } from 'components/IconButton/IconButton'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { useProseStateContext } from 'common/ProseInput/ProseStateContext'
import { observer } from 'mobx-react-lite'

export const EmojiButton = observer(() => {
  const state = useProseStateContext()

  const isDisabled = !state?.view

  const onSelect = (emoji: BaseEmoji) => {
    const view = state?.view
    if (!view) {
      return
    }
    view.dispatch(view.state.tr.insertText(emoji.native))
    view.focus()
  }

  return (
    <DropdownTrigger containFocus={false}>
      <IconButton icon={EmojiIcon} isDisabled={isDisabled} />
      {(close) => (
        <Picker
          autoFocus
          onEmojiSelect={(emoji: BaseEmoji) => {
            onSelect(emoji)
            close()
          }}
        />
      )}
    </DropdownTrigger>
  )
})
